"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableSortableHeaderCellMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Icon = require("../../components/Icon/Icon.styles");
var _TableHeaderCellLabelWrapper = require("../../components/TableHeaderCellLabelWrapper/TableHeaderCellLabelWrapper.styles");
var _TableSortIcon = require("../../components/TableSortIcon/TableSortIcon.styles");
var _TableSortIconWrapper = require("../../components/TableSortIconWrapper/TableSortIconWrapper.styles");
var _constants = require("../../constants");
var _fontSizeMixin = require("../fontSizeMixin");
var _lineHeightMixin = require("../lineHeightMixin");
var _spaceMixin = require("../spaceMixin");
var sortIconCSS = function sortIconCSS(props) {
  var align = props.align,
    size = props.size;
  return (0, _styledToken.default)({
    headerFontType: "Table.headerFontType." + size,
    headerSortIconColor: 'Table.headerSortIconColor'
  }, function (_ref) {
    var headerFontType = _ref.headerFontType,
      headerSortIconColor = _ref.headerSortIconColor;
    var headerFontSize = (0, _fontSizeMixin.fontSizeMixin)(headerFontType, function (fontSize) {
      return fontSize.value;
    })(props);
    var headerLineHeight = (0, _lineHeightMixin.lineHeightMixin)(headerFontType, function (lineHeight) {
      return lineHeight.value;
    })(props);
    return (0, _styledComponents.css)(["", "{margin-", ":", ";color:", ";white-space:nowrap;", "{margin-top:", "px;}}"], _TableSortIconWrapper.StyledTableSortIconWrapper, align === 'right' ? 'right' : 'left', (0, _spaceMixin.spaceMixin)('xs')(props), headerSortIconColor, _Icon.StyledIcon, (headerLineHeight - headerFontSize) / 2);
  })(props);
};
var hoverCSS = function hoverCSS(props) {
  return (0, _styledToken.default)('Table.rowBackgroundColorHover', function (backgroundColor) {
    return (0, _styledComponents.css)(["&&:hover{background-color:", ";cursor:pointer;}"], backgroundColor);
  })(props);
};
var sortableCSS = function sortableCSS(props) {
  var sortDirection = props.sortDirection;
  if (sortDirection !== _constants.TABLE_SORT_DIRECTIONS.none) {
    return '';
  }
  return (0, _styledComponents.css)(["", "{opacity:0;}", ":hover,", ":focus{", "{opacity:1;}}"], _TableSortIcon.StyledTableSortIconSort, _TableHeaderCellLabelWrapper.StyledTableHeaderCellLabelWrapper, _TableHeaderCellLabelWrapper.StyledTableHeaderCellLabelWrapper, _TableSortIcon.StyledTableSortIconSort);
};
var focusCSS = function focusCSS(props) {
  var size = props.size;
  var focusSpread = 4;
  return (0, _styledToken.default)({
    focusBoxShadow: 'Table.boxShadow',
    verticalPadding: "Table.verticalPadding." + size,
    horizontalPadding: "Table.horizontalPadding." + size
  }, function (_ref2) {
    var focusBoxShadow = _ref2.focusBoxShadow,
      verticalPadding = _ref2.verticalPadding,
      horizontalPadding = _ref2.horizontalPadding;
    return (0, _styledComponents.css)(["&&{height:0;height:-moz-fit-content;user-select:none;}", "{display:block;height:100%;position:relative;&:focus{outline:none;box-shadow:none;}&:focus:before{box-shadow:", ";content:'';display:block;outline:none;position:absolute;top:-", "px;right:-", "px;bottom:-", "px;left:-", "px;}}"], _TableHeaderCellLabelWrapper.StyledTableHeaderCellLabelWrapper, focusBoxShadow, verticalPadding - focusSpread, horizontalPadding - focusSpread, verticalPadding - focusSpread, horizontalPadding - focusSpread);
  })(props);
};

/** @class TableSortableHeaderCellMixin */
/** @method */
var TableSortableHeaderCellMixin = function TableSortableHeaderCellMixin(props) {
  return [sortIconCSS(props), hoverCSS(props), sortableCSS(props), focusCSS(props)];
};
exports.TableSortableHeaderCellMixin = TableSortableHeaderCellMixin;